/**
 * @generated SignedSource<<53c3f0edbf4a4976b792d01509ce70ea>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_viewer$data = {
  readonly showAddToCartButton: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPurchaseButton_viewer">;
  readonly " $fragmentType": "PdpRespSidebarButtons_viewer";
};
export type PdpRespSidebarButtons_viewer$key = {
  readonly " $data"?: PdpRespSidebarButtons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_viewer"
    },
    {
      "alias": "showAddToCartButton",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiItemCartAddToCartButton"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiItemCartAddToCartButton\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8babbb8b30aac0595d7aa9b6caf3320d";

export default node;
